<div class="main-content">
  <div class="container-fluid">
    <div class="meeting-step-header">
      <h4>Advice Area</h4>
      <p class="meeting-step-subtitle">
        Draft your formal advice for the project, then submit it to move on to the {{ isPss ? 'closure of the service' : 'final meeting' }}.
      </p>
    </div>

    <router-outlet *ngIf="!loading" name="meeting_4"></router-outlet>
  </div>
</div>
